import { Menu, LogOut, ChevronDown } from 'lucide-react';
import { useAuthContext } from '@/contexts/AuthContext';
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
  DropdownMenuItem,
} from '../ui/DropDownMenu';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { cn } from '@/lib/utils';
import { getMenuList } from '@/utils/getMenuList';
import { ROUTES } from '@/config/const';

const Header = () => {
  const { user, signOut } = useAuthContext();
  const pathname = useLocation().pathname;
  const navigate = useNavigate();
  const menuList = getMenuList(pathname);

  return (
    <header className='z-40 fixed top-0 left-0 right-0'>
      <nav
        className={cn(
          'duration-300 backdrop-filter backdrop-blur-lg backdrop-saturate-200 transition-shadow',
          'bg-white bg-opacity-90 shadow-nav'
        )}
      >
        <div className='container flex justify-between items-center h-16'>
          <Link
            to={ROUTES.dashboard}
            className='self-center text-xl font-semibold whitespace-nowrap'
          >
            Upwork Scraper
          </Link>

          <div className='hidden lg:flex justify-between items-center w-auto'>
            <ul className='flex flex-row gap-2 mt-0 font-medium'>
              {menuList.map(({ href, label, active }) => (
                <li key={label}>
                  <Link
                    to={href}
                    className={cn('block py-2 px-4 text-gray-700 text-sm', {
                      'bg-blue-100 rounded-full text-primary': active,
                    })}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className='flex items-center gap-4'>
            <DropdownMenu>
              <DropdownMenuTrigger asChild className='cursor-pointer py-1'>
                <div className='flex items-center gap-2'>
                  <p className='flex items-center gap-1 text-sm'>
                    Hello
                    {user?.email && (
                      <span className='font-medium hidden sm:inline-block truncate max-w-[150px]'>
                        {user.email}
                      </span>
                    )}
                    <span className='font-medium sm:hidden'>You</span>
                  </p>
                  <ChevronDown size={24} className='text-primary' />
                </div>
              </DropdownMenuTrigger>
              <DropdownMenuContent align='end'>
                <DropdownMenuItem className='cursor-pointer' onClick={signOut}>
                  <LogOut size={18} />
                  <span className='ml-2'>Sign out</span>
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>

            <div className='block lg:hidden'>
              <DropdownMenu>
                <DropdownMenuTrigger asChild>
                  <Menu size={24} className='cursor-pointer' />
                </DropdownMenuTrigger>
                <DropdownMenuContent align='end'>
                  {menuList.map(({ label, href, active }) => (
                    <DropdownMenuCheckboxItem
                      key={label}
                      checked={active}
                      onCheckedChange={() => navigate(href)}
                    >
                      {label}
                    </DropdownMenuCheckboxItem>
                  ))}
                </DropdownMenuContent>
              </DropdownMenu>
            </div>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
